import { render, staticRenderFns } from "./push-message.vue?vue&type=template&id=04f62612&scoped=true"
import script from "./push-message.vue?vue&type=script&lang=js"
export * from "./push-message.vue?vue&type=script&lang=js"
import style0 from "./push-message.vue?vue&type=style&index=0&id=04f62612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f62612",
  null
  
)

export default component.exports